import React, { useEffect, useState } from "react";
import { api } from "@/auth/AuthContext";
import { useT } from "@/i18n/I18nContext";
import { PageHeader, Card, SignalBadge } from "@/components/ui-kit";
import { ArrowUp, ArrowDown, ArrowsClockwise } from "@phosphor-icons/react";

const Scanner = () => {
  const { t, lang } = useT();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.get("/scanner").then(r => r.data);
      setItems(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <PageHeader title={t("scanner.title")} sub={t("scanner.sub")} action={
        <button onClick={load} data-testid="scanner-refresh" className="px-4 py-2 rounded-md text-sm bg-zinc-900 hover:bg-zinc-800 border border-zinc-800 text-zinc-200 transition-colors flex items-center gap-2">
          <ArrowsClockwise size={14} weight="bold" /> {lang === "cs" ? "Obnovit" : "Refresh"}
        </button>
      } />
      <div className="p-4 sm:p-6 lg:p-8">
        <Card className="overflow-hidden">
          {loading ? (
            <div className="p-8 text-center text-zinc-500">Loading...</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-zinc-900/50 border-b border-zinc-800 text-xs font-mono uppercase tracking-wider text-zinc-500">
                  <tr>
                    <th className="px-4 py-3 text-left">Symbol</th>
                    <th className="px-4 py-3 text-left">Type</th>
                    <th className="px-4 py-3 text-right">Price</th>
                    <th className="px-4 py-3 text-right">24h</th>
                    <th className="px-4 py-3 text-right">RSI</th>
                    <th className="px-4 py-3 text-left">Pattern</th>
                    <th className="px-4 py-3 text-right">Confidence</th>
                    <th className="px-4 py-3 text-left">Signal</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((it) => (
                    <tr key={it.symbol} className="border-b border-zinc-900 hover:bg-zinc-900/30 transition-colors" data-testid={`scanner-row-${it.symbol}`}>
                      <td className="px-4 py-3 font-mono font-medium text-zinc-100">{it.symbol}</td>
                      <td className="px-4 py-3 text-xs font-mono uppercase tracking-wider text-zinc-500">{it.type}</td>
                      <td className="px-4 py-3 font-mono text-zinc-200 text-right">{it.price.toLocaleString()}</td>
                      <td className={`px-4 py-3 font-mono text-right ${it.change_24h >= 0 ? "text-green-400" : "text-red-400"}`}>
                        <span className="inline-flex items-center gap-0.5">
                          {it.change_24h >= 0 ? <ArrowUp size={10} weight="bold" /> : <ArrowDown size={10} weight="bold" />}
                          {Math.abs(it.change_24h)}%
                        </span>
                      </td>
                      <td className="px-4 py-3 font-mono text-zinc-300 text-right">{it.rsi}</td>
                      <td className="px-4 py-3 text-sm text-zinc-300">{it.pattern}</td>
                      <td className="px-4 py-3 font-mono text-zinc-200 text-right">{it.confidence}%</td>
                      <td className="px-4 py-3"><SignalBadge direction={it.signal} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>
        <p className="text-xs text-zinc-600 mt-3 font-mono flex items-center gap-2">
          <span className="inline-flex items-center gap-1 text-green-400"><span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" /> LIVE</span>
          {lang === "cs" ? "Živá data z trhu (Yahoo Finance) — obnovují se každých 5 minut." : "Live market data (Yahoo Finance) — refreshes every 5 minutes."}
        </p>
      </div>
    </div>
  );
};

export default Scanner;
